const TokenKey = 'Token'
const JWTKey = 'JWT'

export function getToken() {
  return window.sessionStorage.getItem(TokenKey)
}

export function setToken(token) {
  return window.sessionStorage.setItem(TokenKey, token)
}

export function removeToken() {
  return window.sessionStorage.removeItem(TokenKey)
}

export function setJWT(token) {
  return window.sessionStorage.setItem(JWTKey, token)
}

export function getJWT() {
  return window.sessionStorage.getItem(JWTKey)
}

export function removeJWT() {
  return window.sessionStorage.removeItem(JWTKey)
}
